module.exports = __webpack_public_path__ + "img/17344928.f826dc12.png";